export const navBar = () => {
  return {
    dashboard: 'Tablero',
    help: 'Ayuda',
    send_feedback: 'Enviar Comentarios',
    log_out: 'Cerrar Sesión',
    filters: 'Filtros',
    access_tab: {
      submit: 'Enviar',
      error_message: 'Su requerimento de servicio no pudo ser enviado, por favor intente nuevamente.'
    },
    work_orders: 'Órdenes de Trabajo',
    locations: 'Locaciones',
    account_settings: 'Configuración de la Cuenta',
    company_settings: 'Configuración de Compañía'
  }
}
